function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";

var _ref = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 43.478,
  height: 43.458,
  rx: 13
}), /*#__PURE__*/React.createElement(Path, {
  d: "M20.429 13h18v1.759h-18zm0 5.432h18v1.759h-18zm0 5.432h18v1.759h-18zm0 5.976h18v1.759h-18z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement(G, {
  stroke: "#FFF",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement(Path, {
  d: "M14.861 15.77a2.033 2.033 0 10-4.067 0 2.034 2.034 0 104.067 0z"
}), /*#__PURE__*/React.createElement(Path, {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.655 21.631a3.828 3.828 0 00-7.654 0"
})));

function SvgIconSceneCompositeInactive(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44
  }, props), _ref);
}

export default SvgIconSceneCompositeInactive;